let csrfToken = '';

export function setCsrfToken(value: string | null | undefined): void { csrfToken = value || ''; }
export function getCsrfToken(): string { return csrfToken; }

export function authenticatedFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  const method = (init.method || 'GET').toUpperCase();
  if (method !== 'GET' && method !== 'HEAD' && csrfToken) headers.set('x-csrf-token', csrfToken);
  return fetch(input, { ...init, headers, credentials: 'same-origin' });
}
